interface AnimatedFlowsIconProps {
  className?: string;
}

/**
 * Animated SVG icon with ink-drop effect cycling through 5 content types:
 * chat bubble, image, music, video, document
 */
export function AnimatedFlowsIcon({ className = 'w-4 h-4' }: AnimatedFlowsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="20 12 60 76"
      className={className}
    >
      <defs>
        <style>{`
          .icon-group path,
          .icon-group circle,
          .icon-group polygon,
          .icon-group rect,
          .icon-group polyline,
          .icon-group line {
            fill: none;
            stroke: #111827;
            stroke-width: 1.5;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-dasharray: 120;
            stroke-dashoffset: 120;
            opacity: 0;
          }

          .ink-drop {
            fill: #111827;
            transform-origin: 50px 50px;
            opacity: 0;
          }

          .delay-1 { animation-delay: 0s !important; }
          .delay-2 { animation-delay: 5s !important; }
          .delay-3 { animation-delay: 10s !important; }
          .delay-4 { animation-delay: 15s !important; }
          .delay-5 { animation-delay: 20s !important; }

          .icon-group * { animation: draw-icon 25s infinite; }
          .ink-drop { animation: drop-bounce 25s infinite; }

          @keyframes drop-bounce {
            0% { transform: translateY(35px) scale(0.6, 1.4); opacity: 0; }
            0.5% { opacity: 1; animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94); }
            2.5% { transform: translateY(0) scale(1.3, 0.7); opacity: 1; animation-timing-function: linear; }
            3.5% { transform: translateY(0) scale(0, 0); opacity: 0; }
            15.5% { transform: translateY(0) scale(0, 0); opacity: 0; }
            16.5% { transform: translateY(0) scale(1.3, 0.7); opacity: 1; animation-timing-function: cubic-bezier(0.55, 0.085, 0.68, 0.53); }
            18.5% { transform: translateY(35px) scale(0.6, 1.4); opacity: 1; }
            19%, 100% { opacity: 0; }
          }

          @keyframes draw-icon {
            0%, 2.5% { stroke-dashoffset: 120; opacity: 0; }
            2.6% { opacity: 1; }
            5%, 15% { stroke-dashoffset: 0; opacity: 1; }
            17.5% { stroke-dashoffset: 120; opacity: 1; }
            17.6%, 100% { stroke-dashoffset: 120; opacity: 0; }
          }
        `}</style>
      </defs>

      <g className="icon-wrapper">
        <circle className="ink-drop delay-1" cx="50" cy="50" r="4.5" />
        <g className="icon-group" transform="translate(26, 26) scale(2)">
          <path className="delay-1" d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </g>
      </g>

      <g className="icon-wrapper">
        <circle className="ink-drop delay-2" cx="50" cy="50" r="4.5" />
        <g className="icon-group" transform="translate(26, 26) scale(2)">
          <path className="delay-2" d="M21 11.5v4.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h9" />
          <circle className="delay-2" cx="9" cy="9" r="2" />
          <path className="delay-2" d="M21 15l-5-5L5 21" />
          <path className="delay-2" d="M19 1v6" />
          <path className="delay-2" d="M16 4h6" />
        </g>
      </g>

      <g className="icon-wrapper">
        <circle className="ink-drop delay-3" cx="50" cy="50" r="4.5" />
        <g className="icon-group" transform="translate(26, 26) scale(2)">
          <path className="delay-3" d="M9 18V5l12-2v13"/>
          <circle className="delay-3" cx="6" cy="18" r="3"/>
          <circle className="delay-3" cx="18" cy="16" r="3"/>
        </g>
      </g>

      <g className="icon-wrapper">
        <circle className="ink-drop delay-4" cx="50" cy="50" r="4.5" />
        <g className="icon-group" transform="translate(26, 26) scale(2)">
          <polygon className="delay-4" points="23 7 16 12 23 17 23 7"/>
          <rect className="delay-4" x="1" y="5" width="15" height="14" rx="2" ry="2"/>
        </g>
      </g>

      <g className="icon-wrapper">
        <circle className="ink-drop delay-5" cx="50" cy="50" r="4.5" />
        <g className="icon-group" transform="translate(26, 26) scale(2)">
          <path className="delay-5" d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <polyline className="delay-5" points="14 2 14 8 20 8"/>
          <line className="delay-5" x1="16" y1="13" x2="8" y2="13"/>
          <line className="delay-5" x1="16" y1="17" x2="8" y2="17"/>
          <polyline className="delay-5" points="10 9 9 9 8 9"/>
        </g>
      </g>
    </svg>
  );
}
